import React, { useState } from 'react';
import { connect } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import LayerD from '~/components/Layers/LayerD/LayerD';
import Errors from '~/components/Errors/Errors';
import scrollAnimation from '~/utils/scroll-animation';
import '~/styles/markdown.css';
import css from './Tabs.less';

const btnLeft = require('~/static/common/btn_left.png');
const btnLeftActive = require('~/static/common/btn_left_active.png');
const btnRight = require('~/static/common/btn_right.png');
const btnRightActive = require('~/static/common/btn_right_active.png');

const Tabs = props => {
  const [layerDataD, setLayerDataD] = useState({
    visible: false,
    address: {},
  });

  const showLayerD = item => {
    setLayerDataD({
      visible: true,
      address: item,
    });
  };

  const hideLayerD = () => {
    setLayerDataD({
      visible: false,
      address: {},
    });
  };

  const switchTab = id => {
    const tabElement = document.getElementById(id);
    if (id && tabElement) {
      const targetY = tabElement.offsetTop + 120 || 0;
      scrollAnimation(targetY);
    }
  };

  const { tuan, updateOrders } = props;
  const { product, orders, page, total, totalItems, status } = tuan;
  console.log('tuan:', tuan);
  console.log('tuan:status', status);
  if (status !== 0) {
    return <Errors statusCode={404} />;
  }
  const intro =
    (product.product_intro || '').replace(
      /https:\/\/xindebaby.com\/tuan\//g,
      '/tuan/',
    ) || '';
  return (
    <div className={css.contentMain}>
      <ul className={css.tabs}>
        <li
          className={`${css.tab} ${css.active}`}
          onClick={() => switchTab('detail')}
        >
          团购产品介绍
        </li>
        {product.at_your_door ? (
          <li className={css.tab} onClick={() => switchTab('mode')}>
            服务方式
          </li>
        ) : null}
        {product.shops && product.shops.length >= 1 ? (
          <li className={css.tab} onClick={() => switchTab('shops')}>
            商户地址
          </li>
        ) : null}
        {orders.length >= 1 ? (
          <li className={css.tab} onClick={() => switchTab('orders')}>
            最近订单
          </li>
        ) : null}
        <li className={css.tab} onClick={() => switchTab('mark')}>
          购买须知
        </li>
      </ul>

      <div className={css.item} id="detail">
        <h2 className={css.title}>团购产品介绍</h2>
        {/* markDown 解析 */}
        <div className="markdown">
          <ReactMarkdown source={intro || ''} />
        </div>
      </div>

      {product.at_your_door ? (
        <div className={css.item} id="mode">
          <h2 className={css.title}>服务方式</h2>
          <p className={css.msg}>{product.at_your_door_rule}</p>
        </div>
      ) : null}

      {product.shops && product.shops.length >= 1 ? (
        <div className={css.item} id="shops">
          <h2 className={css.shopsTitle}>商户地址</h2>
          <ul>
            {product.shops.map(item => {
              return (
                <li
                  className={css.shop}
                  key={item.id.toString()}
                  onClick={() => showLayerD(item)}
                >
                  <span>
                    {item.short_name || item.name}：
                    {item.short_address || item.address}
                  </span>{' '}
                  {item.distance || ''}
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}

      {orders.length >= 1 ? (
        <div className={css.item} id="orders">
          <h2 className={css.shopsTitle}>最近订单（{totalItems}）</h2>
          <div className={`flex-space-between ${css.btns}`}>
            <button
              type="button"
              className={css.ordersBtn}
              style={{
                backgroundImage: `url(${page <= 1 ? btnLeft : btnLeftActive})`,
              }}
              onClick={() => updateOrders(page - 1)}
            >
              {' '}
            </button>
            <button
              type="button"
              className={css.ordersBtn}
              style={{
                backgroundImage: `url(${
                  page >= total ? btnRight : btnRightActive
                })`,
              }}
              onClick={() => updateOrders(page + 1)}
            >
              {' '}
            </button>
          </div>
          <ul>
            {orders.map(item => {
              return (
                <li className={css.user} key={item.id.toString()}>
                  <div
                    className={`bg-cover ${css.avatar}`}
                    style={{
                      backgroundImage: `url(${item.user.headimgurl})`,
                    }}
                  >
                    {' '}
                  </div>
                  <p className={`text-hidden-one ${css.name}`}>
                    {item.user.privacy_nickname}
                  </p>
                  <p className={css.time}>付款时间：{item.pay_time}</p>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}

      <div className={css.item} id="mark">
        <h2 className={css.title}>购买须知</h2>
        {/* markDown 解析 */}
        <div className="markdown">
          <ReactMarkdown source={product.group_buying_rule || ''} />
        </div>
      </div>

      {/* 门店地图 */}
      <LayerD
        visible={layerDataD.visible}
        address={layerDataD.address}
        showLayer={showLayerD}
        hideLayer={hideLayerD}
      />
    </div>
  );
};

export default connect(({ tuan }) => ({
  tuan,
}))(Tabs);
